import PropTypes from 'prop-types'
import cn from '../modules/cn'
import Skeleton from './Skeleton'

const HeadingSize = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
}

function Heading({
  children,
  Tag,
  fontSize,
  className,
}) {
  const classNames = ['font-display font-extrabold leading-normal']
  switch (fontSize) {
    case HeadingSize.H2:
      classNames.push('text-h3 2xl:text-h2')
      break
    case HeadingSize.H3:
      classNames.push('text-h4 2xl:text-h3')
      break
    case HeadingSize.H4:
      classNames.push('text-h5 2xl:text-h4')
      break
    case HeadingSize.H5:
      classNames.push('text-h6 2xl:text-h5')
      break
    case HeadingSize.H6:
      classNames.push('text-base 2xl:text-h6')
      break
    default:
      classNames.push('text-h2 2xl:text-h1')
      break
  }

  return (
    <Tag className={cn(classNames, className)}>
      {children || <Skeleton className="h-11 md:h-14 w-full" />}
    </Tag>
  )
}

Heading.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.element]),
  Tag: PropTypes.oneOf(Object.values(HeadingSize)),
  fontSize: PropTypes.oneOf(Object.values(HeadingSize)),
  className: cn.propType,
}

Heading.defaultProps = {
  children: null,
  Tag: HeadingSize.H1,
  fontSize: HeadingSize.H1,
  className: null,
}

Heading.size = HeadingSize

export default Heading
